import { ActionButton } from '@emerald-works-nova/components'
import { Grid, Typography } from '@mui/material'
import { kebabCase } from 'lodash'

import React from 'react'

const Report = ({ name, description, buttonText, onClick, isWorking }) => {
  const testId = kebabCase(name)
  return (
    <Grid
      container
      item
      xs={12}
      sx={{ padding: 4, border: '1px solid #E0E0E0' }}
      justifyContent='space-between'
      alignItems='center'
      data-test={`${testId}-container`}
    >
      <Grid item>
        <Grid item>
          <Typography
            variant='body1'
            fontWeight={500}
            data-test={`${testId}-name`}
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant='subtitle1'
            color='GrayText'
            data-test={`${testId}-description`}
          >
            {description}
          </Typography>
        </Grid>
      </Grid>
      <Grid item>
        <ActionButton
          variant='contained'
          color='primary'
          onClick={onClick}
          isWorking={isWorking}
          data-test={`${testId}-button`}
        >
          {buttonText}
        </ActionButton>
      </Grid>
    </Grid>
  )
}

export default Report
